import { Column, Divider, H2, Link, Row, Box } from "@vp/swan";
import React from "react"

export const AddendumSection = props => {
  const addendumSection = props.addendumSection

  if (!addendumSection || !addendumSection.text || !addendumSection.url) {
    return null
  }

  return (
    <Box mb="7">
      <Row>
        <Column span={12}>
          <H2 className="category-header" fontSize={"x2large"} mb={"5"}>
            <Link
              data-fidoprefetchhint="HOVER"
              href={addendumSection.url}
            >
              {addendumSection.text}
            </Link>
          </H2>
          <Divider />
        </Column>
      </Row>
    </Box>
  );
}

export default AddendumSection
